import { DataEntryAccidentStepProps, typedMemo } from "src/types";
import { AccordionWrapperForm } from "src/ui/widgets";
import { DataEntryAccidentStepGeneralInfo } from "./sections/general_info/accident-step-general-info";
import { DataEntryAccidentStepInjured } from "./sections/injured/accident-step-injured";
import { DataEntryAccidentStepMaterialDamages } from "./sections/material_damages/accident-step-material-damages";
import { DataEntryAccidentStepWitnesses } from "./sections/witnesses/accident-step-witnesses";
import { useDataEntryAccidentStep } from "./data-entry-accident-step.hook";
import { DataEntryAccidentStepCircumstances } from "./sections/accident-circumstances/accident-step-circumstances";

export const DataEntryAccidentStep = typedMemo(
  (props: DataEntryAccidentStepProps) => {
    const { t } = useDataEntryAccidentStep();

    const Title = (
      <div className="title-xs--700 mb-2">
        {t("data_entry.accident_step.title")}
      </div>
    );
    const {
      formikAccidentValues,
      formikAccidentErrors,
      formikAccidentTouched,
      formik,
      validationSchema,
    } = props;

    const Body = (
      <div>
        <AccordionWrapperForm
          sectionKey="generalInfo"
          children={
            <DataEntryAccidentStepGeneralInfo
              formikAccidentValues={formikAccidentValues}
              formikAccidentErrors={formikAccidentErrors}
              formikAccidentTouched={formikAccidentTouched}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.accident_step.section_general_info_title")}
        />
        <AccordionWrapperForm
          sectionKey="injuredsInfo"
          children={
            <DataEntryAccidentStepInjured
              formikAccidentValues={formikAccidentValues}
              formikAccidentErrors={formikAccidentErrors}
              formikAccidentTouched={formikAccidentTouched}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.accident_step.section_injured_title")}
        />
        <AccordionWrapperForm
          sectionKey="materialDamages"
          children={
            <DataEntryAccidentStepMaterialDamages
              formikAccidentValues={formikAccidentValues}
              formikAccidentErrors={formikAccidentErrors}
              formikAccidentTouched={formikAccidentTouched}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.accident_step.section_material_damages_title")}
        />
        <AccordionWrapperForm
          sectionKey="witnessesInfo"
          children={
            <DataEntryAccidentStepWitnesses
              formikAccidentValues={formikAccidentValues}
              formikAccidentErrors={formikAccidentErrors}
              formikAccidentTouched={formikAccidentTouched}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.accident_step.section_witnesses_title")}
        />
        <AccordionWrapperForm
          sectionKey="vehicleAccidentCircumstances"
          children={
            <DataEntryAccidentStepCircumstances
              formikAccidentValues={formikAccidentValues}
              formikAccidentErrors={formikAccidentErrors}
              formikAccidentTouched={formikAccidentTouched}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t(
            "data_entry.accident_step.section_accident_circumstances_title"
          )}
        />
      </div>
    );

    return (
      <div>
        {Title}
        {Body}
      </div>
    );
  }
);
